import Q from 'q';
import _ from 'underscore';

import path from 'js/lib/path';

/**
 * @constructor
 * @param {*} contentRequester - A ContentRequester for the video item.
 * @param {*} sessionId - The sessionId for the assessment
 */
const Requester = function (contentRequester: $TSFixMe, sessionId: $TSFixMe) {
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this._contentRequester = contentRequester;
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this._sessionId = sessionId;
};

Requester.prototype.action = function (name: $TSFixMe, argument: $TSFixMe) {
  return this._contentRequester
    .request(path.join('inVideoQuiz', 'session', this._sessionId, 'action', name), {
      argument,
    })
    .then(_.property('return')); // Extract the 'return' property from the assessment's response.
};

export default Requester;
